import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../Modal.module.scss';
import { FieldValues } from '../types';

const Step22 = (): React.ReactElement => {
  const { register } = useFormContext<FieldValues>();

  return (
    <>
      <div className={styles.modalHeader}>Select a pricing date</div>
      <div className={styles.modalSubHeader}>
        To best process your bond research request, select a pricing date (if any).
      </div>
      <div className={styles.modalFormLine}>
        <div className={styles.modalFormLabel}>
          Pricing date: <span>(if any)</span>
        </div>
        <input
          className={classNames(styles.modalFormInput, styles.modalFormInputDate)}
          type="date"
          placeholder="Select a date"
          onClick={(e) => e.currentTarget.showPicker()}
          {...register('date')}
        />
      </div>
    </>
  );
};

export default Step22;
